export default {"src":"/_next/static/media/PLTR.dd60a385.svg","height":18,"width":18};